import "./Destinations.module.css";
import Header from "@/reusable_sections/Header";
import DestinationsTable from "./sections/DestinationsTable";
import Footer from "@/reusable_sections/Footer";
export default function DestinationsPage() {
  return <div>
      <Header />
      <DestinationsTable />
      <Footer />
    </div>;
}